module.exports = __webpack_public_path__ + "static/media/40.70bc124.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/40.wav
// module id = hyf6
// module chunks = 0